import { useQuery } from "@tanstack/react-query";
import axiosInstance from "axiosConfig";

export type AssetStatusKey = "active" | "withdrawn" | "hidden" | "sold";

export interface UserAssetRow {
  uuid: string;
  name: string | null;
  currencyCode: string | null;
  origin: "reliance" | "other";
  categorySlug: string;
  statusKey: AssetStatusKey | null;
  statusLabel: string | null;
  accessLabel: "Tak" | "Brak" | null;
  infoNote: string | null;
  source: "investment" | "share" | "pool_share";
  investmentUuid: string | null;
  investmentShareUuid: string | null;
  shareId: number | null;
  sharesCount: number | null;
  currencyUuid: string | null;
}

export interface UserAssetCategoryGroup {
  categorySlug: string;
  count: number;
  items: UserAssetRow[];
}

export interface UserAssetsAdminResponse {
  reliance: UserAssetCategoryGroup[];
  other: UserAssetCategoryGroup[];
}

interface GetUserAssetsAdminHookType {
  userUuid?: string;
  asSuccessorOfUuid?: string | null;
  enabled?: boolean;
}

export default function useGetUserAssetsAdmin({
  userUuid,
  asSuccessorOfUuid,
  enabled = true,
}: GetUserAssetsAdminHookType) {
  return useQuery<UserAssetsAdminResponse>({
    queryKey: [
      "investments/admin/user/assets",
      userUuid,
      asSuccessorOfUuid ?? null,
    ],
    queryFn: async () => {
      return axiosInstance
        .get(`/investments/admin/user/${userUuid}/assets`, {
          params: asSuccessorOfUuid ? { asSuccessorOfUuid } : undefined,
        })
        .then((res) => res.data);
    },
    retry: false,
    enabled: enabled && !!userUuid,
    staleTime: 1000 * 15,
  });
}
